/**
 * seo.js — تنظیم متاهای سئوی هر صفحه در سمت کلاینت (SPA)
 * ربات‌ها HTML سرور-رندر (backend/services/seo.service.js) می‌گیرند؛
 * این ابزار برای کاربران و رندر سمت مرورگر است (تب + اشتراک‌گذاری).
 */

const SITE = 'https://zarbehazad.ir';

function setMeta(attr, key, content) {
    if (!content) return;
    try {
        let el = document.head.querySelector(`meta[${attr}="${key}"]`);
        if (!el) {
            el = document.createElement('meta');
            el.setAttribute(attr, key);
            document.head.appendChild(el);
        }
        el.setAttribute('content', content);
    } catch (e) { /* noop */ }
}

/**
 * setSeo({ title, description, path, noindex, image })
 * در بعد از بارگیری داده در ویوها صدا زده می‌شود.
 */
export function setSeo(opts = {}) {
    if (typeof document === 'undefined') return;
    const { title, description, path, image } = opts;
    // notFound → ایندکس‌پذیری را قطع می‌کنیم تا گوگل این URLها را به‌عنوان
    // Soft-404 با robots «index,follow» نگه ندارد (پاک‌سازی تمیز از ایندکس)
    const noindex = !!opts.noindex || !!opts.notFound;
    const finalTitle = title || (opts.notFound ? 'موردی یافت نشد | ضربه آزاد' : null);
    try {
        if (finalTitle) document.title = finalTitle;

        setMeta('name', 'description', description);
        setMeta('property', 'og:title', finalTitle);
        setMeta('property', 'og:description', description);
        if (image) setMeta('property', 'og:image', image);
        setMeta('name', 'robots', noindex ? 'noindex, follow' : 'index, follow, max-image-preview:large');

        // اسلش پایانی: پیش‌رندر استاتیک هاست، صفحات را روی «/مسیر/» سرو می‌کند
        // (URL بدون اسلش ۳۰۱ می‌شود) و سایت‌مپ هم اسلش‌دار است — کانونیکال/og:url
        // باید دقیقاً همان نسخهٔ نهایی باشد تا با HTML خامِ پیش‌رندرهم‌خوان بماند
        const rawPath = path || (window.location && window.location.pathname) || '/';
        const normPath = rawPath !== '/' && !rawPath.endsWith('/') ? rawPath + '/' : rawPath;
        const url = SITE + normPath;
        setMeta('property', 'og:url', url);

        let link = document.head.querySelector('link[rel="canonical"]');
        if (!link) {
            link = document.createElement('link');
            link.setAttribute('rel', 'canonical');
            document.head.appendChild(link);
        }
        link.setAttribute('href', url);
    } catch (e) { /* noop */ }
}
